import type { AppState } from "~/store/root-reducer.ts";
import type { GiftRedemptionState } from "./store-slice.ts";

function selectGiftRedemption(
	state: AppState,
): GiftRedemptionState | undefined {
	return state.gift.giftRedemption;
}

function selectShowCongratulations(state: AppState): boolean {
	return state.gift.giftRedemption?.step?.type === "showCongratulations";
}

function selectShowNameForm(state: AppState): boolean {
	// Show name form when the gift flow is at the showName step
	// But not if the user is already signed in
	return (
		state.gift.giftRedemption?.step?.type === "showName" &&
		state.user.user?.type !== "signedIn"
	);
}

function selectGiftError(state: AppState): string | undefined {
	return state.gift.giftRedemption?.step?.type === "error"
		? state.gift.giftRedemption.step.message
		: undefined;
}

//

export {
	selectGiftRedemption,
	selectShowCongratulations,
	selectShowNameForm,
	selectGiftError,
};
